'use client'
import { Box } from '@mui/material'
import { QuestionHelper } from '../common'
import { useDerivedSwapInfo, useSwapActionHandlers, useSwapState } from '@/state/swap/hooks'
import ColoredSlider from '../ColoredSlider'
import useDebouncedChangeHandler from '@/utils/useDebouncedChangeHandler'
import { useCallback } from 'react'
import { Field } from '@/state/swap/actions'
const PercentageSlider = ({ raffleFormattedAmount, field }: { raffleFormattedAmount: string, field: Field }): JSX.Element => {
  const {
    fractionOfSwapAmount
  } = useSwapState()

  const {
    onFractionOfSwapAmountChange
  } = useSwapActionHandlers()

  const {
    currencies
  } = useDerivedSwapInfo()
  const fractionChangeCallback = useCallback(
    (value: number) => {
      onFractionOfSwapAmountChange(value)
    },
    [onFractionOfSwapAmountChange]
  )

  const [
    fractionPercentage,
    setFractionPercentage
  ] = useDebouncedChangeHandler(
    fractionOfSwapAmount,
    fractionChangeCallback
  )

  const convertPercentageToAmount = useCallback(
    (percentage: number) => {
      const amount = parseFloat(raffleFormattedAmount) * (percentage / 100)
      return amount.toFixed(3)
    },
    [fractionPercentage, raffleFormattedAmount]
  )

  // Calculate the remaining amount that goes to wallet
  const calculateRemainingAmount = useCallback(
    (percentage: number) => {
      const totalAmount = parseFloat(raffleFormattedAmount)
      const raffleAmount = totalAmount * (percentage / 100)
      const remainingAmount = totalAmount - raffleAmount

      return remainingAmount.toFixed(3)
    },
    [fractionPercentage, raffleFormattedAmount]
  )

  return (
    <Box className='w-full'>
      <Box className='flex items-center '>
        <Box className='w-full'>
          <ColoredSlider
            min={1}
            max={100}
            step={1}
            value={fractionPercentage}
            handleChange={(_: any, value: any) =>
              setFractionPercentage(value as number)}
          />
        </Box>
        <small>{fractionOfSwapAmount}%</small>
      </Box>
      {
        field === Field.OUTPUT
          ? (
            <Box className='flex mt-3 mb-3 border rounded-md p-2 border-primary/30 bg-primary/10 text-primary text-center'>
              <small className='mr-2'>{`You will use ${convertPercentageToAmount(fractionPercentage)} USDC to enter raffles and receive ${calculateRemainingAmount(fractionPercentage)} USDC in your wallet.`}</small>
            </Box>
            )
          : (
            <Box className='flex mt-3 mb-3 border rounded-md p-2 border-primary/30 bg-primary/10 text-primary text-center'>
              <small className='mr-2'>{`You will use ${convertPercentageToAmount(fractionPercentage)} USDC to enter raffles and ${parseFloat(raffleFormattedAmount)} USDC will be swapped for ${currencies.OUTPUT?.symbol} `}</small>
            </Box>
            )
      }
    </Box>
  )
}

export const RaffleSwapDetails: React.FC<any> = ({ amount, field }: { amount: string, field: Field }) => {
  return (
    <div className='p-1 w-full'>
      <Box className='flex mb-3'>
        <p className='mr-2'>Percentage</p>
        <QuestionHelper text='You will receive a smaller or bigger amount of tickets based on the percentage you select.' />
      </Box>
      <PercentageSlider raffleFormattedAmount={amount} field={field} />
    </div>
  )
}

